import {HubApiRequest} from '../hub-api-request';
import {HubMethod} from '../constants/methods';
import {v4 as uuidv4} from 'uuid';
import {CheckEmailAvailableReq, CheckEmailAvailableResponse} from '../protocol/check-email-available-req';

export class CheckEmailAvailable extends HubApiRequest<CheckEmailAvailableReq, CheckEmailAvailableResponse> {
    constructor(url: string, deviceIdentifier: string, data: CheckEmailAvailableReq) {
        super(url, HubMethod.CHECK_EMAIL_AVAILABLE, deviceIdentifier, data, uuidv4());
    }
}
